// extracted by mini-css-extract-plugin
export const layoutWidthXL = "1440px";
export const layoutContentWidthXL = "928px";
export const glitterHorizontalXL = "48px";
export const fontSizeSectionTitle = "48px";
export const fontSizeSectionTitleSub = "18px";
export const fontSizeH1 = "36px";
export const fontSizeH2 = "32px";
export const fontSizeH3 = "28px";
export const fontSizeH4 = "24px";
export const fontSizeH5 = "20px";
export const fontSizeH6 = "16px";
export const fontSizeMDSectionTitle = "36px";
export const fontSizeMDSectionTitleSub = "14px";
export const fontSizeSMSectionTitle = "28px";
export const fontSizeSMSectionTitleSub = "12px";
export const fontSizeSMH1 = "28px";
export const fontSizeSMH2 = "24px";
export const fontSizeSMH3 = "20px";
export const fontSizeSMH4 = "16px";
export const fontSizeSMH5 = "12px";
export const fontSizeSMH6 = "10px";
export const fontSizeXSSectionTitle = "20px";
export const fontSizeXSSectionTitleSub = "10px";
export const fontSizeXSH1 = "20px";
export const fontSizeXSH2 = "18px";
export const fontSizeXSH3 = "16px";
export const fontSizeXSH4 = "14px";
export const fontSizeXSH5 = "12px";
export const fontSizeXSH6 = "10px";
export const fontSizeNormal = "16px";
export const fontSizeSmall = "14px";
export const fontSizeXSmall = "12px";